import {createSelector} from '@ngrx/store';
import {resourceItemEntityAdapter as EntityAdapter, ResourceItemState as EntityState} from "./resource-item.state";
import {ResourceItem as Entity} from './resource-item.model';
import {AppState} from "src/app/store/app-store.state";

export const selectState = (state: AppState) => state.resourceItem;

export const selectAll = createSelector(selectState, EntityAdapter.getSelectors().selectAll);

export const selectById = (entityId: string) =>
  createSelector(selectAll, (entities: Entity[]) => entities.find(p => p.id === entityId));

export const isLoading = createSelector(selectState, (state: EntityState) => state.isLoading);

export const hasErrors = createSelector(selectState, (state: EntityState) => state.error);

export const findByCorrelationId = <T>(correlationId: string) => createSelector(
  selectState,
  (state: EntityState) => <T>state.history.find(h => h.correlationId === correlationId)?.payload
);

export const currentEntityId = createSelector(selectState, (state: EntityState) => state.currentEntityId);

export const currentEntity = createSelector(selectState, (state: EntityState) => {
  return state.currentEntityId
    ? state.entities[state.currentEntityId]
    : undefined
});

export const currentEntities = createSelector(selectState, (state: EntityState) => {
  return state.currentPageEntities
    ? state.currentPageEntities.map(id => state.entities[id]).filter(y => y !== undefined)
    : undefined;
});

export const currentPageEntities = createSelector(selectState, (state: EntityState) => {
  return state.currentPageEntities
    ? state.currentPageEntities.map(id => state.entities[id]).filter(y => y !== undefined)
    : undefined;
});

export const totalPageable = createSelector(selectState, (state: EntityState) => state.currentPage.totalCount);
export const currentPage = createSelector(selectState, (state: EntityState) => state.currentPage.page);
export const currentSort = createSelector(selectState, (state: EntityState) => state.currentSort);
export const ResourceItemSelectors = {
  selectAll,
  selectById,
  isLoading,
  hasErrors,
  findByCorrelationId,
  currentEntity,
  currentEntityId,
  currentEntities,
  currentPageEntities,
  totalPageable,
  currentPage,
  currentSort
};
